import axios from "axios";
import { removeAuthToken } from "./token-utils";

declare module "axios" {
  interface AxiosRequestConfig {
    // The backend also answers 401 when NetSuite fails, so requests for
    // optional data set this to show an error instead of logging the user out
    skipAuthRedirect?: boolean;
  }
}

export const axiosClient = axios.create({
  baseURL: "https://partner.bidfoodme.com/api/v1/",
  withCredentials: true,
});

// Create a custom event for unauthorized access
export const unauthorizedEvent = new Event('unauthorized-access');

let isRedirecting = false; // Prevent multiple redirects

// Add response interceptor
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.skipAuthRedirect &&
      !isRedirecting
    ) {
      isRedirecting = true;
      
      // Remove the auth token
      removeAuthToken();
      
      // Dispatch the unauthorized event
      window.dispatchEvent(unauthorizedEvent);
      
      // Redirect to login
      const currentPath = window.location.pathname;
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
    }
    return Promise.reject(error);
  }
);